module.exports = __webpack_public_path__ + "img/radio-btn.8bcc16bc.svg";